/**
 * Selector Preferences API Client
 * Per-employee favourites and recently used items for the timesheet project and
 * cost centre selectors. The API allows the employee themselves or someone
 * authorised to enter time for them.
 */

import { apiClient } from '@/services/apiClient';

export type SelectorPreferenceType = 'project' | 'costCentre';

export interface SelectorRecentItem {
  id: string;
  timestamp: number;
}

export interface SelectorPreferences {
  favourites: string[];
  recentlyUsed: SelectorRecentItem[];
}

export interface SelectorPreferencesDto extends SelectorPreferences {
  /** False when nothing has been saved for this employee yet. */
  exists: boolean;
}

function endpoint(employeeId: number, selectorType: SelectorPreferenceType, companyId?: string): string {
  const query = companyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
  return `/selector-preferences/${employeeId}/${selectorType}${query}`;
}

export async function getSelectorPreferences(
  employeeId: number,
  selectorType: SelectorPreferenceType,
  companyId?: string,
): Promise<SelectorPreferencesDto> {
  return apiClient.get<SelectorPreferencesDto>(endpoint(employeeId, selectorType, companyId));
}

export async function saveSelectorPreferences(
  employeeId: number,
  selectorType: SelectorPreferenceType,
  preferences: SelectorPreferences,
  companyId?: string,
): Promise<SelectorPreferencesDto> {
  return apiClient.put<SelectorPreferencesDto, SelectorPreferences>(
    endpoint(employeeId, selectorType, companyId),
    preferences,
  );
}
